import React from 'react'

import Text from 'components/common/Text'
import Icon from 'components/Icon'
import theme from 'theme'
import { pluralize } from 'utils/strings'

type IconCounter = {
  icon: string
  link?: string
  label: string
  count: number | undefined
}

type IconCounterGroupProps = {
  counts: IconCounter[]
}

const IconCounterGroup: React.FC<IconCounterGroupProps> = ({
  counts,
  ...rest
}) => {
  return (
    <div
      css={{
        display: 'flex',
        alignItems: 'center',
        paddingTop: theme.space[3],
        paddingBottom: theme.space[3],
        fontSize: theme.fontSizes[1]
      }}
      {...rest}
    >
      {counts
        .filter((entry) => Number.isFinite(entry.count))
        .map((entry) => (
          <React.Fragment key={entry.label}>
            <Icon
              css={{
                marginRight: theme.space[2],
                color: theme.colors.steel[1]
              }}
              icon={entry.icon}
            />
            {entry.link ? (
              <Text
                as="a"
                css={{
                  fontWeight: theme.fontWeights[0],
                  color: theme.colors.steel[1],
                  '&:hover': {
                    textDecoration: 'underline'
                  },
                  '&:not(:last-child)': {
                    marginRight: theme.space[3]
                  }
                }}
                href={entry.link}
              >
                {entry.count} {pluralize(entry.label, entry.count)}
              </Text>
            ) : (
              <Text
                as="span"
                css={{
                  fontWeight: theme.fontWeights[0],
                  color: theme.colors.steel[1],
                  '&:not(:last-child)': {
                    marginRight: theme.space[3]
                  }
                }}
              >
                {entry.count} {pluralize(entry.label, entry.count)}
              </Text>
            )}
          </React.Fragment>
        ))}
    </div>
  )
}

export default IconCounterGroup
